import animatedLogo from "@/assets/images/animated_logo.gif";
const Loader = ({ text = "loading.." }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <img src={animatedLogo} alt="brand animated logo" className="w-20 h-20" />
      <p className=" text-sm font-medium text-gray-400">{text}</p>
    </div>
  );
};

export default Loader;
